/**
 * 复制到粘贴板
 * @param value
 */
export function copy(value: string) {
  const textarea = document.createElement('textarea');
  textarea.readOnly = true;
  textarea.style.zIndex = '0';
  textarea.style.opacity = '0';
  textarea.style.top = '-9999px';
  textarea.style.left = '-9999px';
  textarea.style.position = 'fixed';
  document.body.appendChild(textarea);
  textarea.value = value;

  const range = document.createRange();
  range.selectNode(textarea);
  const selection = window.getSelection();
  if (selection) {
    selection.addRange(range);
  }

  textarea.select();
  document.execCommand('SelectAll');
  document.execCommand('copy');
  document.body.removeChild(textarea);
};
